import React, { useEffect } from "react";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, LabelList } from 'recharts';
import ResponsiveLegend from "utils/ResponsiveLegendChart";
import { formateMonthName } from "utils/formats";

export default function DespesaEstruturalChart({ despesaEstruturalData }) {

    const [chartAndTableData, setChartAndTableData] = React.useState([]);
    const { getLegendPosition, windowWidth } = ResponsiveLegend();

    useEffect(() => {
        if (despesaEstruturalData && despesaEstruturalData.length > 0) {
            let mappedData = despesaEstruturalData.map((data) => ({
                name: formateMonthName(data.mesAno),
                telefoniaInternet: data.telefoniaInternet,
                manutencaoGeral: data.manutencaoGeral,
                materialEscritorio: data.materialEscritorio,
                juridico: data.juridico,
                acoesVendas: data.acoesVendas,
                motoboy: data.motoboy,
                aguaEsgoto: data.aguaEsgoto,
                contribuicaoSindical: data.contribuicaoSindical,
                uniformes: data.uniformes,
                processoJudicial: data.processoJudicial,
                fretesCarreto: data.fretesCarreto,
                iRAluguel: data.irAluguel,
                outrasDespesasEstruturais: data.outrasDespesasEstruturais,
                limpezaHigiene: data.limpezaHigiene,
                energiaEletrica: data.energiaEletrica,
                contabilidade: data.contabilidade,
                sistemas: data.sistemas,
                seguros: data.seguros,
                eventos: data.eventos,
                segurancaMonitoramento: data.segurancaMonitoramento,
                empresaTerceirizada: data.empresaTerceirizada,
                recrutamentoSelecao: data.recrutamentoSelecao,
                despesaGrafica: data.despesaGrafica,
                representacoesViagensTransporte: data.representacoesViagensTransporte,
                perdaRouboBaixaEstoque: data.perdaRouboBaixaEstoque,
                telefoniaInternetPdv: data.telefoniaInternetPdv,
                manutencaoGeralPdv: data.manutencaoGeralPdv,
                materialEscritorioPdv: data.materialEscritorioPdv,
                juridicoPdv: data.juridicoPdv,
                acoesVendasPdv: data.acoesVendasPdv,
                motoboyPdv: data.motoboyPdv,
                aguaEsgotoPdv: data.aguaEsgotoPdv,
                contribuicaoSindicalPdv: data.contribuicaoSindicalPdv,
                uniformesPdv: data.uniformesPdv,
                processoJudicialPdv: data.processoJudicialPdv,
                fretesCarretoPdv: data.fretesCarretoPdv,
                iRAluguelPdv: data.irAluguelPdv,
                outrasDespesasEstruturaisPdv: data.outrasDespesasEstruturaisPdv,
                limpezaHigienePdv: data.limpezaHigienePdv,
                energiaEletricaPdv: data.energiaEletricaPdv,
                contabilidadePdv: data.contabilidadePdv,
                sistemasPdv: data.sistemasPdv,
                segurosPdv: data.segurosPdv,
                eventosPdv: data.eventosPdv,
                segurancaMonitoramentoPdv: data.segurancaMonitoramentoPdv,
                empresaTerceirizadaPdv: data.empresaTerceirizadaPdv,
                recrutamentoSelecaoPdv: data.recrutamentoSelecaoPdv,
                despesaGraficaPdv: data.despesaGraficaPdv,
                representacoesViagensTransportePdv: data.representacoesViagensTransportePdv,
                perdaRouboBaixaEstoquePdv: data.perdaRouboBaixaEstoquePdv
            }));
            setChartAndTableData(mappedData);
        }
    }, [despesaEstruturalData]);

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            const pdvTelefoniaInternet = `R$ ${data.telefoniaInternetPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvManutencaoGeral = `R$ ${data.manutencaoGeralPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvMaterialEscritorio = `R$ ${data.materialEscritorioPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvJuridico = `R$ ${data.juridicoPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvAcoesVendas = `R$ ${data.acoesVendasPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvMotoboy = `R$ ${data.motoboyPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvAguaEsgoto = `R$ ${data.aguaEsgotoPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvContribuicaoSindical = `R$ ${data.contribuicaoSindicalPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvUniformes = `R$ ${data.uniformesPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvProcessoJudicial = `R$ ${data.processoJudicialPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvFretesCarreto = `R$ ${data.fretesCarretoPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvIRAluguel = `R$ ${data.iRAluguelPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvOutrasDespesasEstruturais = `R$ ${data.outrasDespesasEstruturaisPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvLimpezaHigiene = `R$ ${data.limpezaHigienePdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvEnergiaEletrica = `R$ ${data.energiaEletricaPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvContabilidade = `R$ ${data.contabilidadePdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvSistemas = `R$ ${data.sistemasPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvSeguros = `R$ ${data.segurosPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvEventos = `R$ ${data.eventosPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvSegurancaMonitoramento = `R$ ${data.segurancaMonitoramentoPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvEmpresaTerceirizada = `R$ ${data.empresaTerceirizadaPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvRecrutamentoSelecao = `R$ ${data.recrutamentoSelecaoPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvDespesaGrafica = `R$ ${data.despesaGraficaPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvRepresentacoesViagensTransporte = `R$ ${data.representacoesViagensTransportePdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvPerdaRouboBaixaEstoque = `R$ ${data.perdaRouboBaixaEstoquePdv.toLocaleString('pt-BR').split(',')[0]}`;
            return (
                <div className="custom-tooltip" style={{ lineHeight: '0.9px', fontSize: '12px', backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
                    <p>{data.name}</p>
                    <p>TELEFONIA E INTERNET/PDV: {pdvTelefoniaInternet}</p>
                    <p>MANUTENÇÃO EM GERAL/PDV: {pdvManutencaoGeral}</p>
                    <p>MATERIAL DE ESCRITÓRIO/PDV: {pdvMaterialEscritorio}</p>
                    <p>JURÍDICO/PDV: {pdvJuridico}</p>
                    <p>AÇÕES DE VENDAS/PDV: {pdvAcoesVendas}</p>
                    <p>MOTOBOY/PDV: {pdvMotoboy}</p>
                    <p>ÁGUA E ESGOTO/PDV: {pdvAguaEsgoto}</p>
                    <p>CONTRIBUIÇÃO SINDICAL/PDV: {pdvContribuicaoSindical}</p>
                    <p>UNIFORMES/PDV: {pdvUniformes}</p>
                    <p>PROCESSO JUDICIAL/PDV: {pdvProcessoJudicial}</p>
                    <p>FRETES E CARRETOS/PDV: {pdvFretesCarreto}</p>
                    <p>IR SOBRE ALUGUEL/PDV: {pdvIRAluguel}</p>
                    <p>OUTRAS ESTRUTURAS/PDV: {pdvOutrasDespesasEstruturais}</p>
                    <p>LIMPEZA E HIGIENE/PDV: {pdvLimpezaHigiene}</p>
                    <p>ENERGIA ELÉTRICA/PDV: {pdvEnergiaEletrica}</p>
                    <p>CONTABILIDADE/PDV: {pdvContabilidade}</p>
                    <p>SISTEMAS/PDV: {pdvSistemas}</p>
                    <p>SEGURO/PDV: {pdvSeguros}</p>
                    <p>EVENTOS/PDV: {pdvEventos}</p>
                    <p>SEGURANÇA E MONITORAMENTO/PDV: {pdvSegurancaMonitoramento}</p>
                    <p>EMPRESAS TERCEIRIZADAS/PDV: {pdvEmpresaTerceirizada}</p>
                    <p>RECRUTAMENTO E SELEÇÃO/PDV: {pdvRecrutamentoSelecao}</p>
                    <p>DESPESAS GRÁFICAS/PDV: {pdvDespesaGrafica}</p>
                    <p>VIAGENS, REPRESENTAÇÕES, TRANSPORTES, E CONDUÇÕES/PDV: {pdvRepresentacoesViagensTransporte}</p>
                    <p>PERDA, ROUBO OU BAIXA DE ESTOQUE/PDV: {pdvPerdaRouboBaixaEstoque}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <div>
            <ResponsiveContainer width='99%' height={750}>
                <ComposedChart
                    width={1200}
                    height={400}
                    data={chartAndTableData}
                    margin={{
                        top: 20,
                        right: 30,
                        bottom: 10,
                        left:5
                    }}
                >
                    <XAxis 
                        dataKey="name"
                        stroke="#000" 
                        axisLine={false}
                        tickLine={false} 
                        style={{textAlign: "center",fontWeight: 'bold',padingLeft:'5px'}}
                    />
                    <YAxis hide />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend
                        align={windowWidth > 600 ? 'left' : 'center'}
                        layout={windowWidth > 600 ? 'vertical' : 'horizontal'}
                        iconSize={12}
                        wrapperStyle={(windowWidth > 600) ? { ...getLegendPosition(),  minWidth: '140px', width: '140px',maxWidth: '140px' , textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'overlay'} : { ...getLegendPosition() }}
                        formatter={(value, entry) => <span style={{ color: '#000', fontSize: '10px' }}>{value}</span>}
                        payload={[
                            { value: 'TELEFONIA E INTERNET/PDV', type: "line", color: "#f09081" },
                            { value: 'MANUTENÇÃO EM GERAL/PDV', type: "line", color: "#fce33d" },
                            { value: 'MATERIAL DE ESCRITÓRIO/PDV', type: "line", color: "#fc0015" },
                            { value: 'JURÍDICO/PDV', type: "line", color: "#2b3845" },
                            { value: 'AÇÕES DE VENDAS/PDV', type: "line", color: "#77bf24" },
                            { value: 'MOTOBOY/PDV', type: "line", color: "#25e8a4" },
                            { value: 'ÁGUA E ESGOTO/PDV', type: "line", color: "#04718a" },
                            { value: 'CONTRIBUIÇÃO SINDICAL/PDV', type: "line", color: "#02c3f0" },
                            { value: 'UNIFORMES/PDV', type: "line", color: "#606f90" },
                            { value: 'PROCESSO JUDICIAL/PDV', type: "line", color: "#c1dff5" },
                            { value: 'FRETES E CARRETOS/PDV', type: "line", color: "#f203ff" },
                            { value: 'IR SOBRE ALUGUEL/PDV', type: "line", color: "#5c0723" },
                            { value: 'OUTRAS ESTRUTURAS/PDV', type: "line", color: "#fc0015" },
                            { value: 'LIMPEZA E HIGIENE/PDV', type: "line", color: "#736869" },
                            { value: 'ENERGIA ELÉTRICA/PDV', type: "line", color: "#f78c00" },
                            { value: 'CONTABILIDADE/PDV', type: "line", color: "#fa3719" },
                            { value: 'SISTEMAS/PDV', type: "line", color: "#2b3845" },
                            { value: 'SEGURO/PDV', type: "line", color: "#8dc4aa" },
                            { value: 'EVENTOS/PDV', type: "line", color: "#f59fc1" },
                            { value: 'SEGURANÇA E MONITORAMENTO/PDV', type: "line", color: "#91093f" },
                            { value: 'EMPRESAS TERCEIRIZADAS/PDV', type: "line", color: "#00735c" },
                            { value: 'RECRUTAMENTO E SELEÇÃO/PDV', type: "line", color: "#133608" },
                            { value: 'DESPESAS GRÁFICAS/PDV', type: "line", color: "#b4fa9d" },
                            { value: 'VIAGENS, REPRESENTAÇÕES, TRANSPORTES, E CONDUÇÕES/PDV', type: "line", color: "#7609b5" },
                            { value: 'PERDA, ROUBO OU BAIXA DE ESTOQUE/PDV', type: "line", color: "#f5b547" }

                        ]}
                    />

                    <Bar
                        dataKey="telefoniaInternetPdv"
                        fill="none"
                    />
                    <Line type="linear" strokeWidth='2' dataKey="telefoniaInternetPdv" name="TELEFONIA E INTERNET/PDV" stroke="#f09081" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="manutencaoGeralPdv" name="MANUTENÇÃO EM GERAL/PDV" stroke="#fce33d" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="materialEscritorioPdv" name="MATERIAL DE ESCRITÓRIO/PDV" stroke="#fc0015" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="juridicoPdv" name="JURÍDICO/PDV" stroke="#4a6e21" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="acoesVendasPdv" name="AÇÕES DE VENDAS/PDV" stroke="#77bf24" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="motoboyPdv" name="MOTOBOY/PDV" stroke="#25e8a4" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="aguaEsgotoPdv" name="ÁGUA E ESGOTO/PDV" stroke="#04718a" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="contribuicaoSindicalPdv" name="CONTRIBUIÇÃO SINDICAL/PDV" stroke="#02c3f0" dot={false}> </Line>
                    <Line type="linear" strokeWidth='2' dataKey="uniformesPdv" name="UNIFORMES/PDV" stroke="#02c3f0" dot={false}> </Line>
                    <Line type="linear" strokeWidth='2' dataKey="processoJudicialPdv" name="PROCESSO JUDICIAL/PDV" stroke="#7609b5" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="fretesCarretoPdv" name="FRETES E CARRETOS/PDV" stroke="#7609b5" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="iRAluguelPdv" name="IR SOBRE ALUGUEL/PDV" stroke="#f203ff" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="outrasDespesasEstruturaisPdv" name="OUTRAS ESTRUTURAS/PDV" stroke="#5c0723" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="limpezaHigienePdv" name="LIMPEZA E HIGIENE/PDV" stroke="#736869" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="energiaEletricaPdv" name="ENERGIA ELÉTRICA/PDV" stroke="#f78c00" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="contabilidadePdv" name="CONTABILIDADE/PDV" stroke="#fa3719" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="sistemasPdv" name="SISTEMAS/PDV" stroke="#2b3845" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="segurosPdv" name="SEGURO/PDV" stroke="#606f90" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="eventosPdv" name="EVENTOS/PDV" stroke="#42a76f" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="segurancaMonitoramentoPdv" name="SEGURANÇA E MONITORAMENTO/PDV" stroke="#606f90" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="empresaTerceirizadaPdv" name="EMPRESAS TERCEIRIZADAS/PDV" stroke="#42a76f" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="recrutamentoSelecaoPdv" name="RECRUTAMENTO E SELEÇÃO/PDV" stroke="#606f90" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="despesaGraficaPdv" name="DESPESAS GRÁFICAS/PDV" stroke="#42a76f" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="representacoesViagensTransportePdv" name="VIAGENS, REPRESENTAÇÕES, TRANSPORTES, E CONDUÇÕES/PDV" stroke="#606f90" dot={false}></Line>
                    <Line type="linear" strokeWidth='2' dataKey="perdaRouboBaixaEstoquePdv" name="PERDA, ROUBO OU BAIXA DE ESTOQUE/PDV" stroke="#42a76f" dot={false}></Line>
                </ComposedChart>
            </ResponsiveContainer>
            <div style={{ marginBottom: '8px', marginRight: '40px' }}>
                <tr style={{ fontSize: '10px' }}>
                    <th>POR PDV:</th>
                </tr>
                <table
                    style={{
                        width: '100%',
                        borderTop: '1px solid #000',
                        borderBottom: '1px solid #000',
                        overflow: 'auto',
                        tableLayout: 'fixed'
                    }}>
                    <tbody style={{ fontSize: '10px' }}>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>TELEFONIA E INTERNET</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.telefoniaInternetPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>MANUTENÇÃO EM GERAL</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.manutencaoGeralPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>MATERIAL DE ESCRITÓRIO</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.materialEscritorioPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>JURÍDICO</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.juridicoPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>AÇÕES DE VENDAS</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.acoesVendasPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>MOTOBOY</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.motoboyPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>ÁGUA E ESGOTO</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.aguaEsgotoPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>CONTRIBUIÇÃO SINDICAL</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.contribuicaoSindicalPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>UNIFORMES</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.uniformesPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>PROCESSO JUDICIAL</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.processoJudicialPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>FRETES E CARRETOS</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.fretesCarretoPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>IR SOBRE ALUGUEL</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.iRAluguelPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>OUTRAS ESTRUTURAS</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.outrasDespesasEstruturaisPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>LIMPEZA E HIGIENE</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.limpezaHigienePdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>ENERGIA ELÉTRICA</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.energiaEletricaPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>CONTABILIDADE</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.contabilidadePdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>SISTEMAS</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.sistemasPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>SEGURO</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.segurosPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>EVENTOS</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.eventosPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>SEGURANÇA E MONITORAMENTO</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.segurancaMonitoramentoPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>EMPRESAS TERCEIRIZADAS</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.empresaTerceirizadaPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>RECRUTAMENTO E SELEÇÃO</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.recrutamentoSelecaoPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>DESPESAS GRÁFICAS</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.despesaGraficaPdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>VIAGENS, REPRESENTAÇÕES, TRANSPORTES, E CONDUÇÕES</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.representacoesViagensTransportePdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>PERDA, ROUBO OU BAIXA DE ESTOQUE</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.perdaRouboBaixaEstoquePdv.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1px solid #000' }}></tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}
